import React from "react";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";

export default function Career() {
  return (
    <div className="slider-wrapper">
      <div className="container">
        <div className="row mt63">
          <div className="col-sm-12">
            <div className="mainbdr whitebg">
              <div className="row">
                <div className="col-sm-3">
                  <Sidebar />
                </div>
                <div class="col-sm-9 " style={{ marginTop: "5px" }}>
                  <div class="row mt0">
                    <div class="col-sm-12">
                      <div class="inner_content contactpage">
                        <h2>IMPORTANT LINKS</h2>
                        <div class="clearfix"></div>
                        <div class="impotant_link">
                          <ul>
                            <li>
                              {" "}
                              <a
                                href="http://pharmaceuticals.gov.in/"
                                target="_blank"
                              >
                                Department of Pharmaceuticals
                              </a>
                            </li>
                            <li>
                              {" "}
                              <a
                                href="http://janaushadhi.gov.in/"
                                target="_blank"
                              >
                                {" "}
                                Janaushadhi
                              </a>
                            </li>
                            <li>
                              {" "}
                              <a
                                href="http://www.nppaindia.nic.in/"
                                target="_blank"
                              >
                                {" "}
                                National Pharmaceutical Pricing Authority (NPPA)
                              </a>
                            </li>
                            <li>
                              {" "}
                              <a
                                href="http://hindantibiotics.gov.in/"
                                target="_blank"
                              >
                                {" "}
                                Hindustan Antibiotics Limited (HAL)
                              </a>
                            </li>
                            <li>
                              {" "}
                              <a
                                href="http://www.rdpl-india.in/"
                                target="_blank"
                              >
                                {" "}
                                Rajasthan Drugs & Pharmaceuticals Limited (RDPL)
                              </a>
                            </li>
                            <li>
                              {" "}
                              <a
                                href="http://www.kaplindia.com/home.asp"
                                target="_blank"
                              >
                                {" "}
                                Karnataka Antibiotics & Pharmaceuticals Limited
                                (KAPL)
                              </a>
                            </li>
                            <li>
                              {" "}
                              <a
                                href="http://bengalchemicals.gov.in/"
                                target="_blank"
                              >
                                Bengal Chemicals & Pharmaceuticals Limited
                                (BCPL)
                              </a>
                            </li>
                            <li>
                              {" "}
                              <a
                                href="http://www.niperahm.ac.in/"
                                target="_blank"
                              >
                                {" "}
                                National Institute of Pharmaceutical Education
                                and Research, Ahmedabad
                              </a>
                            </li>
                            <li>
                              {" "}
                              <a
                                href="http://www.niperhyd.ac.in/"
                                target="_blank"
                              >
                                {" "}
                                National Institute of Pharmaceutical Education
                                and Research, Hyderabad
                              </a>
                            </li>
                            <li>
                              {" "}
                              <a
                                href="http://niperhajipur.ac.in/"
                                target="_blank"
                              >
                                {" "}
                                National Institute of Pharmaceutical Education
                                and Research, Hajipur
                              </a>
                            </li>
                            <li>
                              {" "}
                              <a
                                href="http://www.niperkolkata.edu.in/"
                                target="_blank"
                              >
                                {" "}
                                National Institute of Pharmaceutical Education
                                and Research, Kolkata
                              </a>
                            </li>
                            <li>
                              {" "}
                              <a
                                href="http://niperguwahati.ac.in/"
                                target="_blank"
                              >
                                {" "}
                                National Institute of Pharmaceutical Education
                                and Research, Guwahati
                              </a>
                            </li>
                            <li>
                              {" "}
                              <a
                                href="http://niperraebareli.edu.in/"
                                target="_blank"
                              >
                                National Institute of Pharmaceutical Education
                                and Research, Rai Barelli
                              </a>
                            </li>
                            <li>
                              {" "}
                              <a href="http://www.niper.ac.in/" target="_blank">
                                {" "}
                                National Institute of Pharmaceutical Education
                                and Research, S.A.S. Nagar
                              </a>
                            </li>
                            <li>
                              {" "}
                              <a
                                href="http://www.cdsco.nic.in/forms/Default.aspx"
                                target="_blank"
                              >
                                {" "}
                                Central Drug Standard Control Organisation
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <Footer />
            </div>

            <div className="clearfix"></div>
          </div>
        </div>
      </div>
    </div>
  );
}
